import { getEnvVar } from 'shared/src/utils/env'

export const makeNewPostRoute = (userId?: number) =>
  userId ? `/users/${userId}/posts` : '/posts'

export const makeCreatePostRoute = (userId?: number) =>
  userId ? `/users/${userId}/posts/create` : '/posts/create'

export const makeCreatePostProductRoute = (userId?: number) =>
  userId ? `/users/${userId}/posts/products/create` : '/posts/products/create'

export const makeEditPostRoute = (id: number, userId?: number) =>
  userId ? `/users/${userId}/posts/${id}` : `/posts/${id}`

export const makeEditUserListRoute = (
  id: number,
  userId?: number,
  isEdit?: boolean
) => {
  let path = userId ? `/users/${userId}/userLists/${id}` : `/userLists/${id}`

  if (isEdit) {
    path += '/edit'
  }

  return path
}

export const makeRegisterUserRoute = (email?: string) =>
  email ? `/register?user=${encodeURIComponent(email)}` : '/register'

export const makeAdminCreatorEarningsRoute = (userId: number) =>
  `/users/${userId}/earnings`

export const makeAdminCreatorInsightsRoute = (userId: number) =>
  `/users/${userId}/insights`

export const makeDayEarningsRoute = (date: string) => `/creatorEarnings/${date}`

export const makeUserEarningsRoute = (userId: number) =>
  `/creatorEarnings/user/${userId}`

export const makeShopperProfileUrl = (username: string): string =>
  getEnvVar('SHOPPER_URL').concat('/', username)

export const makeShopperProfileRodeoPostUrl = (
  username: string,
  mediaId: number
): string =>
  [getEnvVar('SHOPPER_URL'), username, 'posts/rodeo#' + mediaId].join('/')

export const makeAdminProductRoute = (productId: number) =>
  `/products/${productId}`
